"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DestroyableScheduler = void 0;
var AbstractDestroyable_1 = require("./AbstractDestroyable");
var DestroyableScheduler = /** @class */ (function (_super) {
    __extends(DestroyableScheduler, _super);
    function DestroyableScheduler() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.tracker = new Map();
        return _this;
    }
    DestroyableScheduler.prototype.timeout = function (key, ms, callback) {
        var lk = "".concat(key, ".last");
        var nk = "".concat(key, ".next");
        var exec = this.createExec(lk, nk, callback);
        clearTimeout(this.tracker.get(nk));
        this.tracker.set(nk, setTimeout(exec, ms));
    };
    DestroyableScheduler.prototype.windowed = function (key, msWindow, callback) {
        var _a;
        var lk = "".concat(key, ".last");
        var nk = "".concat(key, ".next");
        var now = performance.now();
        var last = ((_a = this.tracker.get(lk)) !== null && _a !== void 0 ? _a : Number.MAX_SAFE_INTEGER);
        if (now - last >= msWindow) {
            // Invoke now
            var exec = this.createExec(lk, nk, callback);
            exec();
        }
        else {
            // Schedule
            var ms = msWindow - (now - last);
            this.timeout(key, ms, callback);
        }
    };
    DestroyableScheduler.prototype.destroy = function () {
        var e_1, _a;
        _super.prototype.destroy.call(this);
        try {
            for (var _b = __values(this.tracker.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                if (key.endsWith('.next')) {
                    clearTimeout(this.tracker.get(key));
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.tracker.clear();
    };
    DestroyableScheduler.prototype.createExec = function (lk, nk, callback) {
        var _this = this;
        return function () {
            callback();
            _this.tracker.set(lk, performance.now());
            clearTimeout(_this.tracker.get(nk));
            _this.tracker.delete(nk);
        };
    };
    return DestroyableScheduler;
}(AbstractDestroyable_1.AbstractDestroyable));
exports.DestroyableScheduler = DestroyableScheduler;
